import { getErrorMessages } from "../../../services/errors";
import { ErrorResponse } from "../../../services/types";

export const toErrorMessage = (err: unknown) =>
  getErrorMessages(err as ErrorResponse | string).join(" ");
